import { useEffect, useState } from 'react';
import useMounted from '@sdk/utils/hooks/useMounted';
import useSlingApi from '@sdk/api/useSlingApi';
import useAuth from '@sdk/authentication/useAuth';
import type { DayPart } from '@sdk/dayParts/types/apiTypes';

export type DayPartsState = {
  loadDayPartsError: string;
  initialDayParts: DayPart[];
  setInitialDayParts: (dayParts: DayPart[]) => void;
  dayParts: DayPart[];
  setDayParts: (dayParts: DayPart[]) => void;
};

export const useDayParts = (): DayPartsState => {
  const [loadDayPartsError, setLoadDayPartsError] = useState('');
  const [initialDayParts, setInitialDayParts] = useState<DayPart[]>([]);
  const [dayParts, setDayParts] = useState<DayPart[]>([]);
  const mountedRef = useMounted();
  const api = useSlingApi();
  const { currentUser } = useAuth();

  useEffect(() => {
    (async (): Promise<void> => {
      try {
        if (currentUser.org.isPremium) {
          const { data } = await api.dayParts.getAllDayParts();
          setInitialDayParts(data);
          setDayParts(data);
        }
      } catch ({ data }) {
        if (mountedRef.current) {
          setLoadDayPartsError(data.message);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loadDayPartsError,
    initialDayParts,
    setInitialDayParts,
    dayParts,
    setDayParts,
  };
};
